// دمج عميق لملفات الترجمة: المفاتيح المتشابهة في الأعلى (مثل platform) لا تُلغي بعضها.
export const deepMerge = (...sources) =>
  sources.reduce((out, src) => {
    Object.entries(src || {}).forEach(([key, value]) => {
      const isPlain = (v) => v && typeof v === "object" && !Array.isArray(v);
      out[key] = isPlain(value) && isPlain(out[key]) ? deepMerge(out[key], value) : value;
    });
    return out;
  }, {});
